import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { Dataset } from 'app/model/dataset/dataset';


@Metamodel.model({
    abstract: true
})

export abstract class StoreReadSettings extends Named {

    public static readonly MODEL: IModel;
    public static readonly MAXCONCURRENT_CONNECTIONS: IAttribute;

    // shared among all 11 file-type data stores
    @Metamodel.attribute({
        templatable: true,
        association: 'MAXCONCURRENT_CONNECTIONS',
        display: stringResources.ModelName_MaxConcurrentConnections,
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public maxConcurrentConnections?: number;

    public init(dataset: Dataset): void {
        // abstract class doesn't need to do anything here, leave it empty rather than abstract function so child class doesn't have to implement it
    }
    // when source ls type is changed, storeSettings will be reset for adapation. Call this func to restore storeSetting property values from the previous one
    public abstract recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void;

    protected updateModelValue(propName: string, curStoreSettings: StoreReadSettings, prevStoreSettings: StoreReadSettings): void {
        if (curStoreSettings && prevStoreSettings && Metamodel.modelOf(prevStoreSettings).hasAttribute(propName) && Metamodel.modelOf(curStoreSettings).hasAttribute(propName)) {
            const curAttribute = Metamodel.modelOf(curStoreSettings).attribute(propName);
            const prevAttribute = Metamodel.modelOf(prevStoreSettings).attribute(propName);
            if (prevAttribute.templateValue(prevStoreSettings) != null) {
                curAttribute.setTemplateValue(curStoreSettings, prevAttribute.templateValue(prevStoreSettings));
            } else {
                curAttribute.setValue(curStoreSettings, prevAttribute.value(prevStoreSettings));
            }
        }
    }

}
